<div class="tt-c-add-video">
  <tt-header class="tt-c-add-video__header" :heading="$msg('addVideo.heading')"></tt-header>
  <div class="tt-c-add-video__items">
    <tt-review-flow-product class="tt-c-add-video__item" :catItem="catItem" :siblingSiteKey="siblingSiteKey"></tt-review-flow-product>
    <div class="tt-c-add-video__form">
      <tt-text-field v-model="videoLink"
                      id="tt-review-video-link"
                      class="tt-c-add-video__field"
                      :hintText="$msg('addVideo.info')"
                      :errorText="errorText"
                      :label="$msg('addVideo.youtubeLink')"
                      :success="isValidLink"
                      name="tt-review-video-link"></tt-text-field>
      <div class="tt-c-add-video__actions tt-o-button-group">
        <div v-show="isSubmitting" class="tt-o-spinner tt-o-spinner--submit"></div>
        <tt-button v-show="!isSubmitting"
                   type="primary"
                   @click="add"
                   class="tt-c-add-video__button tt-c-add-video__button-add"
                   aria-describedby="tt-add-video-add-desc"
                   v-html="$msg('addVideo.add')"></tt-button>
        <tt-button @click="back" class="tt-c-add-video__button tt-c-add-video__button-back" type="secondary" v-html="$msg('addVideo.back')"></tt-button>
      </div>
    </div>
  </div>
  <tt-review-flow-footer id="tt-add-video-add-desc" class="tt-c-add-video__footer" :texts="[$msg('addVideo.terms')]"></tt-review-flow-footer>
</div>
